//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const CreateChildTicketLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-add-big-24'
      text={t('ticketPage.createTicketLink')}
    />
  )
}

CreateChildTicketLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default CreateChildTicketLink
